const configAggregator = (node) => {
    return {
        testimonial: node.getAttribute('data-element')
    }
}

export default configAggregator
